import { IDesignerBoard } from '@components/pages/DesignerProfile/graphql/designer-boards.graphql';
import React from 'react';

export interface IBoardImagesModal {
  boards: IDesignerBoard[];
  boardId: string;
}

export interface IBoardImagesModalContext {
  open: (state: IBoardImagesModal) => void;
}

/* istanbul ignore next */
const BoardImagesModalContext = React.createContext<IBoardImagesModalContext>({
  open: () => null,
});

export default BoardImagesModalContext;
